export function shouldEnableImageGenerationSocket(pathname: string | null) {
  // The global notification bridge polls tracked tasks after route changes, so
  // keeping an idle generation socket open on Writer and other pages only
  // creates reconnect noise when the generation endpoint closes idle clients.
  return pathname === "/research-drawing" || Boolean(pathname?.startsWith("/research-drawing/"));
}
